// src/components/cofounder/QuickActions.js
import React from 'react';
import { BarChart2, Package, Search, Mail, DollarSign, CheckCircle, Users } from 'lucide-react';

const quickActions = [
  { label: 'Analyze sales', prompt: 'Analyze my sales trends for this month compared to last month.', icon: BarChart2 },
  { label: 'Check inventory', prompt: 'What items are running low on stock? Are there any items I need to reorder?', icon: Package },
  { label: 'Find suppliers', prompt: 'Help me find potential suppliers in my network for my business needs.', icon: Search },
  { label: 'Review finances', prompt: 'Give me a financial health overview. How is my cash flow this month?', icon: DollarSign },
  { label: 'Draft email', prompt: 'Help me draft a professional email to a client or supplier.', icon: Mail },
  { label: 'Upcoming tasks', prompt: 'What tasks are due soon or overdue? Help me prioritize.', icon: CheckCircle },
  { label: 'Find customers', prompt: 'Help me find potential customers in the network for my products/services.', icon: Users }
];

const QuickActions = ({ onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 px-4 py-3">
      {quickActions.map((action, i) => {
        const Icon = action.icon;
        return (
          <button
            key={i}
            onClick={() => onSelect(action.prompt)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full
              bg-white border border-gray-200 text-xs font-medium text-gray-700
              hover:bg-purple-50 hover:border-[#190192] hover:text-[#190192]
              transition-colors"
          >
            <Icon size={12} />
            {action.label}
          </button>
        );
      })}
    </div>
  );
};

export default QuickActions;
